import React from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { trackButtonClick } from "@/utils/analytics";
import { footerCmsData } from "@/redux/cms/cmsSelectors";
import Partners from "../Partners";
import LivevoxChat from "@/components/pdp/pdpComponents/LivevoxChat";
import { useCookieConsent } from "@/components/cookie/CookieConsentContext";
import "./Footer.css";

const NewFooter = ({ isMapOpen = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const cmsData = useSelector(footerCmsData);
  const { openManageCookies } = useCookieConsent();
  const FairHousingIcon = "/assets/images/home/Fair_Housing_Icon_New.svg";
  const isDashboardPage = location.pathname.startsWith("/my-shopper/");

  // Check if current page is a PDP Page
// const isPDPPage = location.pathname.startsWith("/property/");
  const isPDPPage = location.pathname.startsWith("/property/") ||
    location.pathname.startsWith("/bank-owned-home/", "") ||
    location.pathname.startsWith("/short-sale-home/", "") ||
    location.pathname.startsWith("/non-bank-owned-home/", "") ||
    location.pathname.startsWith("/foreclosure-home/", "") ||
    location.pathname.startsWith("/second-chance-home/", "") ||
    location.pathname.startsWith("/absolute-auction-home/", "") ||
    location.pathname.startsWith("/non-performing-loan/", "") ||
    location.pathname.startsWith("/commercial-building/", "") ||
    location.pathname.startsWith("/bank-owned-home/preview/", "") ||
    location.pathname.startsWith("/short-sale-home/preview/", "") ||
    location.pathname.startsWith("/non-bank-owned-home/preview/", "") ||
    location.pathname.startsWith("/foreclosure-home/preview/", "") ||
    location.pathname.startsWith("/second-chance-home/preview/", "") ||
    location.pathname.startsWith("/absolute-auction-home/preview/", "") ||
    location.pathname.startsWith("/non-performing-loan/preview/", "") ||
    location.pathname.startsWith("/commercial-building/preview/", "");

  // Handle contact us click
  const handleContactUsClick = (e) => {
    e.preventDefault();
    if (isPDPPage) {
      const currentUrl = location.pathname;
      navigate("/contact-us", { state: { propertyUrl: currentUrl } });
    } else {
      navigate("/contact-us");
    }
  };

  //socila Icons
  const ICONS_MAP = {
    facebook: "/assets/images/home/New_Fb_Icon.svg",
    instagram: "/assets/images/home/New_Insta_Icon.svg",
    linkedin: "/assets/images/home/New_Linkedin_Icon.svg",
    youtube: "/assets/images/home/New_Youtube_Icon.svg",
    // twitter: "/assets/images/home/New_Twitter_Icon.svg",
  };

  const externalRoutes = ["/sell-a-home-in-an-online-auction/","/blog/"];
  //routing paths
  const routePaths = {
    contactUs: "/contact-us",
    listAHome: "/sellahomeinanonlineauction",
    faqs: "/support",
    siteMap: "/site-map",
    aboutUs: "/about/about-us",
    // pressReleases: "/blog/category/press-releases/",
    inTheNews: "/blog/",
    careers: "/about/careers",
    blog: "/blog/",
  };

  return (
    <footer id="main-footer" className="p-0 main_footer container-fluid text-white" data-map-open={isMapOpen}>
      <div id="" className="container-fluid ">
        <div id="footer-main-row" className="row  footer-row-mobile-reorder g-0 g-md-3">
          {/* Logo and Description */}
          <div
            id="footer-left-column"
            className={`${
              isMapOpen
                ? "col-md-12 footer-bottom-border pb-4"
                : "col-lg-6 footer-right-border pb-5 px-5"
            }  footer-col-logo  mt-0`}
          >
            <div
              id="footer-logo-social-section"
              className="d-flex justify-content-start  mb-3 mt-5 logo-social"
            >
              <img
                id="footer-logo"
                src="/assets/images/home/New_Footer_Logo.svg"
                alt="Hubzu Logo"
                className="img-fluid cursor-pointer logo-hubzu-new"
                style={{ height: "72px" }}
                onClick={() => navigate("/")}
              />
              <div
                id="footer-social-links"
                className={`d-flex justify-content-around align-items-end ${
                  isMapOpen ? "px-0" : "px-5"
                }  footer-social`}
              >
                {cmsData?.updatedSocialLinks?.["@nodes"]?.map((nodeName) => {
                  const socialNode = cmsData?.updatedSocialLinks[nodeName];
                  if (!socialNode) return null;
                  const Icon = ICONS_MAP[nodeName.toLowerCase()];
                  const url = socialNode?.url || "#";
                  return (
                    <a
                      id={`social-${nodeName}`}
                      key={nodeName}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-2"
                    >
                      <img
                        id={`social-icon-${nodeName}`}
                        src={Icon}
                        alt={nodeName}
                      />
                    </a>
                  );
                })}
              </div>
            </div>
            <p id="footer-about" className="footer-about mb-3">
              {cmsData?.inclusivityContent}
            </p>
            <p id="footer-trec-info" className="footer-trec-para pt-2">
              <a
                id="trec-brokerage"
                href={cmsData?.brokerageService?.url}
                className="text-decoration-none footer-trec-color"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>TREC:</strong> {cmsData?.brokerageService?.label}
              </a>{" "}
              <span className="footer-trec-para-seperator">| </span>
              <a
                id="consumer-protection"
                href={cmsData?.consumerProtection?.url}
                className="text-decoration-none footer-trec-color"
                target="_blank"
                rel="noopener noreferrer"
              >
                {cmsData?.consumerProtection?.label}
              </a>
            </p>
            <p id="footer-ny-info" className="mb-3 footer-trec-para">
              <a
                  rel="noreferrer"
                id="ny-fair-housing"
                href={cmsData?.newyorkFairHousingNotice?.url}
                className="text-decoration-none footer-trec-color"
                target="_blank"
              >
                {cmsData?.newyorkFairHousingNotice?.label}
              </a>{" "}
              <span className="footer-trec-para-seperator">| </span>
              <a
                  rel="noreferrer"
                id="ny-operating-procedures"
                href={cmsData?.newyorkStandarizedOperatingProcedures?.url}
                className="text-decoration-none footer-trec-color"
                target="_blank"
              >
                {cmsData?.newyorkStandarizedOperatingProcedures?.label}
              </a>
            </p>
            <p id="footer-fair-housing" className="pt-2">
              <img
                id="fair-housing-icon"
                src={FairHousingIcon}
                alt={FairHousingIcon}
              />{" "}
              {cmsData?.fairHousingLinks &&
                Object.entries(cmsData.fairHousingLinks)
                  .filter(
                    ([key, value]) =>
                      !key.startsWith("@") && value?.label && value?.url
                  )
                  .map(([key, link], index, filteredArray) => {
                    // Normalize absolute hubzu.com URLs to relative paths for consistency
                    const normalizedUrl = link.url.replace(/^https?:\/\/(www\.)?hubzu\.com/, '');
                    return (
                    <React.Fragment key={link.label}>
                      <a
                        id={`${key}`}
                        href={normalizedUrl}
                        className="text-decoration-none footer-trec-para"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.label}
                      </a>
                      <span className="footer-trec-para-seperator">
                        {index < filteredArray.length - 1 && " | "}
                      </span>
                    </React.Fragment>
                    );
                  })}
            </p>
            <p
              id="footer-copyright"
              className="footer-trec-para pt-3"
              tabIndex="0"
            >
              {cmsData?.newCopyRights}
            </p>
          </div>
          <div
            id="footer-right-column"
            className={`${
              isMapOpen ? "col-md-12 pb-3 mt-0" : "col-lg-6"
            } footer-col-right mt-0`}
          >
            <div id="footer-right-row" className="row row-h-50">
              <div
                id="footer-app-download-section"
                className="col-md-4 footer-col-download footer-right-border pl-4"
              >
                <h4 id="footer-app-download-title" className="text-white download-app-heading mb-3">
                  Download the App
                </h4>
                <div id="footer-app-links" className="d-flex flex-column">
                  <a
                    href={cmsData?.appleStore}
                    className="mb-2"
                    target="_blank"
                    rel="noreferrer"
                    id="app-store-link"
                    onClick={() => {
                      trackButtonClick({
                        eventName: "footer_app_download_click",
                        eventCategory: "Home Page 2.0",
                        eventSource: `Apple Store click`,
                        eventParams: { store: "apple_app_store" },
                        eventLabel: `Apple App store`,
                      });
                    }}
                  >
                    <img
                      id="app-store-image"
                      src="/assets/images/home/social_App_Store_New_Icon.svg"
                      alt="Download on App Store"
                      style={{ width: "120px", height: "40px" }}
                    />
                  </a>
                  <a
                    href={cmsData?.googlePlayStore}
                    target="_blank"
                        rel="noreferrer"
                    id="play-store-link"
                    onClick={() => {
                      trackButtonClick({
                        eventName: "footer_app_download_click",
                        eventCategory: "Home Page 2.0",
                        eventSource: `Google play store click`,
                        eventParams: { store: "google_play" },
                        eventLabel: `Google play store`,
                      });
                    }}
                  >
                    <img
                      id="play-store-image"
                      src="/assets/images/home/Play_Store_New_Icon.svg"
                      alt="Get it on Google Play"
                      style={{ width: "120px", height: "40px" }}
                    />
                  </a>
                </div>
              </div>
              {cmsData?.updatedFooterLinks?.["@nodes"]?.map(
                (nodeName, index) => {
                  if (index >= 2) return null;
                  const section = cmsData?.updatedFooterLinks?.[nodeName];
                  const filteredLinks = section?.links;
                  const colClass =
                    index === 1
                      ? "footer-col-help"
                      : "footer-col-about footer-right-border";

                  return (
                    <div
                      id={`footer-section-${nodeName}`}
                      key={nodeName}
                      className={`col-md-4 ${colClass}`}
                    >
                      <h4
                        id={`footer-section-title-${nodeName}`}
                        className="text-white mb-3 footer-about-help-heading"
                      >
                        {section?.header || ""}
                      </h4>
                      <div className="text-center d-none d-lg-block mx-4">
                      <ul
                        id={`footer-links-list-${nodeName}`}
                        className={`${index === 0 ? 'left-align-about' : 'left-align-help'}`}
                      >
                        {filteredLinks?.map((link, linkIndex) => {
                          const linkId = link
                            ?.trim()
                            ?.split(/\s+/)
                            .map((word, idx) =>
                              idx === 0
                                ? word.toLowerCase()
                                : word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase()
                            )
                            .join("");
                          const route = routePaths[linkId];
                          return (
                            <li
                              id={`footer-link-item-${nodeName}-${linkIndex}`}
                              key={link}
                              className="mb-2"
                            >
                              {link?.toLowerCase() === "support" ? (
                                <LivevoxChat
                                  showContent={false}
                                  showContentTitle={false}
                                  contentText={link}
                                  style={{ color: "white" }}
                                  hideContactUsTextClass={true}
                                />
                              ) : route && externalRoutes.includes(route) ? (
                                <a
                                  id={`footer-link-${linkId}`}
                                  href={route || "#"}
                                  className="text-light text-decoration-none small"
                                >
                                  {link || "Untitled Link"}
                                </a>
                              ) : linkId === "contactUs" ? (
                                <a
                                  id={`footer-link-${linkId}`}
                                  href="#"
                                  onClick={handleContactUsClick}
                                  className="text-light text-decoration-none small"
                                >
                                  {link || "Untitled Link"}
                                </a>
                              ) : (
                                <Link
                                  id={`footer-link-${linkId}`}
                                  to={route}
                                  className="text-light text-decoration-none small"
                                >
                                  {link || "Untitled Link"}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                        {index === 1 && (
                          <li
                            id="footer-link-item-manage-cookies"
                            className="mb-2"
                          >
                            <a
                              id="footer-link-manageCookies"
                              href="#"
                              className="text-light text-decoration-none small"
                              onClick={(e) => {
                                e.preventDefault();
                                openManageCookies();
                              }}
                            >
                              Manage Cookies
                            </a>
                          </li>
                        )}
                      </ul>
                      </div>
                      <div className="d-lg-none">
                      <ul
                        id={`footer-links-list-${nodeName}`}
                        className={`${index === 0 ? 'left-align-about' : 'left-align-help'}`}
                      >
                        {filteredLinks?.map((link, linkIndex) => {
                          const linkId = link
                            ?.trim()
                            ?.split(/\s+/)
                            .map((word, idx) =>
                              idx === 0
                                ? word.toLowerCase()
                                : word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase()
                            )
                            .join("");
                          const route = routePaths[linkId];
                          return (
                            <li
                              id={`footer-link-item-${nodeName}-${linkIndex}`}
                              key={link}
                              className="mb-2"
                            >
                              {link?.toLowerCase() === "support" ? (
                                <LivevoxChat
                                  showContent={false}
                                  showContentTitle={false}
                                  contentText={link}
                                  style={{ color: "white" }}
                                  hideContactUsTextClass={true}
                                />
                              ) : route && externalRoutes.includes(route) ? (
                                <a
                                  id={`footer-link-${linkId}`}
                                  href={route || "#"}
                                  className="text-light text-decoration-none small"
                                >
                                  {link || "Untitled Link"}
                                </a>
                              ) : linkId === "contactUs" ? (
                                <a
                                  id={`footer-link-${linkId}`}
                                  href="#"
                                  onClick={handleContactUsClick}
                                  className="text-light text-decoration-none small"
                                >
                                  {link || "Untitled Link"}
                                </a>
                              ) : (
                                <Link
                                  id={`footer-link-${linkId}`}
                                  to={route}
                                  className="text-light text-decoration-none small"
                                >
                                  {link || "Untitled Link"}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                        {index === 1 && (
                          <li
                            id="footer-link-item-manage-cookies-mobile"
                            className="mb-2"
                          >
                            <a
                              id="footer-link-manageCookies-mobile"
                              href="#"
                              className="text-light text-decoration-none small"
                              onClick={(e) => {
                                e.preventDefault();
                                openManageCookies();
                              }}
                            >
                              Manage Cookies
                            </a>
                          </li>
                        )}
                      </ul>
                      </div>
                    </div>
                  );
                }
              )}
            </div>
            <div id="footer-partners-row" className="row  footer-col-partners">
              <div id="footer-partners-column" className="col-12">
                <div
                  id="footer-partners-container"
                  className="partners-responsive-container pt-4"
                >
                  <Partners flexWrap={isMapOpen || isDashboardPage} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
